<template>
    <section class="space-section " id="service-section">
      <b-row class="justify-content-center">
        <b-col cols="12" sm="12" md="12" lg="12" xl="10">
          <div>
            <!-- <h5 class="text-center title-section-c">{{ $t('header.services') }}</h5>
            <p class="text-center content-section">{{ $t('services.content')}}</p> -->
            
            <h5 class="text-center gotham-med tm-title">{{ $t('header.services') }}</h5>
            <p class="text-center gotham-book tm-content cont-service-sm">{{ $t('services.content') }}</p>
            <!-- cont-service-sm -->
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col  sm="12" md="6" lg="5" xl="5" offset-lg="1" offset-xl="1">
          <ul class="ul-services">
            <li class="li-service"><a v-on:click="setCurrentI(0,2)" id="service0" class="a-service">{{ $t('services.branding') }}</a></li><br>
            <li class="li-service"><a v-on:click="setCurrentI(1,2)" id="service1" class="a-service" >{{ $t('services.motion') }}</a></li><br>
            <li class="li-service"><a v-on:click="setCurrentI(2,2)" id="service2" class="a-service">{{ $t('services.experience') }}</a></li><br>
            <li class="li-service"><a v-on:click="setCurrentI(3,2)" id="service3" class="a-service">{{ $t('services.managment') }}</a></li><br>
            <li class="li-service"><a v-on:click="setCurrentI(4,2)" id="service4" class="a-service">{{ $t('services.design') }}</a></li><br>
            <li class="li-service"><a v-on:click="setCurrentI(5,2)" id="service5" class="a-service">{{ $t('services.story') }}</a></li><br>
            <li class="li-service"><a v-on:click="setCurrentI(6,2)" id="service6" class="a-service">{{ $t('services.interface') }}</a></li><br>
          </ul>

          <ul class="ul-services-sm">
            
            <li class="li-service-sm"><a v-on:click="setCurrentI(7,1)" id="service7" class="a-service-sm">{{ $t('services.branding') }}</a></li><br>
            <div class="div-svideo-sm" :class="[animate, fadeRight,slow]"  id="id-div-svideo7">
              <b-icon icon="x" class="close-tar" @click="closeTarjet(7)" variant="light" font-scale="2.5"></b-icon>
              <VideoSm :src="video_url" :ref="video_ref" :poster="poster_url" :textVideo="text_video" :claseId="claseId"></VideoSm>
            </div>
            <li class="li-service-sm"><a v-on:click="setCurrentI(8,1)" id="service8" class="a-service-sm" >{{ $t('services.motion') }}</a></li><br>
            <div class="div-svideo-sm" :class="[animate, fadeRight,slow]" id="id-div-svideo8">
              <b-icon icon="x" class="close-tar" @click="closeTarjet(8)" variant="light" font-scale="2.5"></b-icon>
              <VideoSm :src="video_url" :ref="video_ref" :poster="poster_url" :textVideo="text_video" :claseId="claseId"></VideoSm>
            </div>
            <li class="li-service-sm"><a v-on:click="setCurrentI(9,1)" id="service9" class="a-service-sm" >{{ $t('services.experience') }}</a></li><br>
            <div class="div-svideo-sm" :class="[animate, fadeRight,slow]" id="id-div-svideo9">
              <b-icon icon="x" class="close-tar" @click="closeTarjet(9)" variant="light" font-scale="2.5"></b-icon>
              <VideoSm :src="video_url" :ref="video_ref" :poster="poster_url" :textVideo="text_video" :claseId="claseId"></VideoSm>
            </div>
            <li class="li-service-sm"><a v-on:click="setCurrentI(10,1)" id="service10" class="a-service-sm" >{{ $t('services.managment') }}</a></li><br>
            <div class="div-svideo-sm" :class="[animate, fadeRight,slow]" id="id-div-svideo10">
              <b-icon icon="x" class="close-tar" @click="closeTarjet(10)" variant="light" font-scale="2.5"></b-icon>
              <VideoSm :src="video_url" :ref="video_ref" :poster="poster_url" :textVideo="text_video" :claseId="claseId"></VideoSm>
            </div>
            <li class="li-service-sm"><a v-on:click="setCurrentI(11,1)" id="service11" class="a-service-sm" >{{ $t('services.design') }}</a></li><br>
            <div class="div-svideo-sm" :class="[animate, fadeRight,slow]" id="id-div-svideo11">
              <b-icon icon="x" class="close-tar" @click="closeTarjet(11)" variant="light" font-scale="2.5"></b-icon>
              <VideoSm :src="video_url" :ref="video_ref" :poster="poster_url" :textVideo="text_video" :claseId="claseId"></VideoSm>
            </div>
            <li class="li-service-sm"><a v-on:click="setCurrentI(12,1)" id="service12" class="a-service-sm" >{{ $t('services.story') }}</a></li><br>
            <div class="div-svideo-sm" :class="[animate, fadeRight,slow]" id="id-div-svideo12">
              <b-icon icon="x" class="close-tar" @click="closeTarjet(12)" variant="light" font-scale="2.5"></b-icon>
              <VideoSm :src="video_url" :ref="video_ref" :poster="poster_url" :textVideo="text_video" :claseId="claseId"></VideoSm>
            </div>
            <li class="li-service-sm"><a v-on:click="setCurrentI(13,1)" id="service13" class="a-service-sm" >{{ $t('services.interface') }}</a></li><br>
            <div class="div-svideo-sm" :class="[animate, fadeRight,slow]" id="id-div-svideo13">
              <b-icon icon="x" class="close-tar" @click="closeTarjet(13)" variant="light" font-scale="2.5"></b-icon>
              <VideoSm :src="video_url" :ref="video_ref" :poster="poster_url" :textVideo="text_video" :claseId="claseId"></VideoSm>
            </div>
          </ul>
        </b-col>
        <div class="trailer-back" ref="back_video" :style="{display:visibilityCloseLg}">
          <b-icon icon="x" @click="close_lg" ref="iconClose" :style="{ display: visibilityCloseLg }" class="close-lg"></b-icon>
        </div>
        <b-col  offset-lg="1" offset-xl="1" sm="12" md="5" lg="5" xl="5">
          
          <div :class="[animate, fadeRight,slow]" class="div-svideo" id="id-div-svideo">
            <div class="title-video">
              <p class="text-video-service" id="video-text">{{text_video}}</p>
            </div> 
            <!-- <b-icon icon="x" @click="close_lg" ref="iconClose" :style="{ display: visibilityCloseLg }" class="close-lg"></b-icon> -->
            <!-- <div class="text-center embed-responsive-16by9" :class="[enbebed,minVideo,fullVideoLg]">
              <video ref="video_ser" muted="muted" :class="videoService" v-bind:poster="poster_url">
                <source v-bind:src="video_url" v-bind:type="video_mime">
              </video>
            </div> -->

            <div class="text-center" :class="[minVideo,fullVideoLg]">
              <!-- <video ref="video_ser" muted="muted" :class="videoService" v-bind:poster="poster_url">
                <source v-bind:src="video_url" v-bind:type="video_mime">
              </video> -->
              <img ref="video-img" :class="[marg , imgTam]" :src="poster_url" alt="servicio">
              <span class="title-span" ref="span_title">{{titleSpan}}</span>
            </div>
            <button class="btn_project" v-on:click="setProject(claseId)" >{{ $t('services.lookProject') }}</button>
            <div class="button-video-service" @click="start_lg">
              <b-icon :icon="iconVideo"></b-icon>
            </div>
          </div>
        </b-col>
      </b-row>
    </section>
</template>

<script>
import VideoSm from './VideoSm'
export default {  
  name: 'Services',
  components:{
    VideoSm
  },
  data(){
    return{
      iconVideo: "play",
      url:"Mar_Fondo_Low.mp4",
      video_ref:"",
      video_url:require('@/assets/video/Mar_Fondo_Low.mp4'),
      video_mime: 'video/mp4',
      fullVideoLg:"",
      minVideo:"div-video-service",
      enbebed:"embed-responsive",
      videoService:"video-service",
      titleSpan:"",
      visibilityCloseLg: "none",
      animate: "animate__animated",
      fadeRight:"animate__fadeInRight",
      slow:"animate__slow 0.5s",
      poster_url:require('@/assets/img/Branding.jpg'),
      text_video:this.$i18n.t('services.textBranding'),
      marg:"marg",
      imgTam:"img-resp",
      claseId:0,
      link:0,
      actived:33,
      slides:[
        {
          id:0,
          src:require('@/assets/video/Mar_Fondo_Low.mp4'),
          title:"_"+this.$i18n.t('services.branding'),
          title_noactive:this.$i18n.t('services.branding'),
          post:require('@/assets/img/Branding.jpg'),
          text:'services.textBranding'
        },{
          id:1,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.motion'),
          title_noactive:this.$i18n.t('services.motion'),
          post:require('@/assets/img/MotionGraphics.jpg'),
          text:'services.textMotion'
        },{
          id:2,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.experience'),
          title_noactive:this.$i18n.t('services.experience'),
          post:require('@/assets/img/UserExperience.jpg'),
          text:'services.textExperience'
        },{
          id:3,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.managment'),
          title_noactive:this.$i18n.t('services.managment'),
          post:require('@/assets/img/CommunityManagement.jpg'),
          text:'services.textManagement'
        },{
          id:4,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.design'),
          title_noactive:this.$i18n.t('services.design'),
          post:require('@/assets/img/GraphicDesign.jpg'),
          text:'services.textDesign'
        },{
          id:5,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.story'),
          title_noactive:this.$i18n.t('services.story'),
          post:require('@/assets/img/Storytelling.jpg'),
          text:'services.textStory'
        },{
          id:6,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.interface'),
          title_noactive:this.$i18n.t('services.interface'),
          post:require('@/assets/img/UserInterface.jpg'),
          text:'services.textInterface'
        },{
          id:7,
          src:require('@/assets/video/Mar_Fondo_Low.mp4'),
          title:"_"+this.$i18n.t('services.branding'),
          title_noactive:this.$i18n.t('services.branding'),
          post:require('@/assets/img/Branding.jpg'),
          text:'services.textBranding'
        },{
          id:8,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.motion'),
          title_noactive:this.$i18n.t('services.motion'),
          post:require('@/assets/img/MotionGraphics.jpg'),
          text:'services.textMotion'
        },{
          id:9,
          src:require('@/assets/video/Mar_Fondo_Low.mp4'),
          title:"_"+this.$i18n.t('services.experience'),
          title_noactive:this.$i18n.t('services.experience'),
          post:require('@/assets/img/UserExperience.jpg'),
          text:'services.textExperience'
          
        },{
          id:10,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.managment'),
          title_noactive:this.$i18n.t('services.managment'),
          post:require('@/assets/img/CommunityManagement.jpg'),
          text:'services.textManagement'

        },{
          id:11,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.design'),
          title_noactive:this.$i18n.t('services.design'),
          post:require('@/assets/img/GraphicDesign.jpg'),
          text:'services.textDesign'
        },{
          id:12,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.story'),
          title_noactive:this.$i18n.t('services.story'),
          post:require('@/assets/img/Storytelling.jpg'),
          text:'services.textStory'
        },{
          id:13,
          src:require('@/assets/video/Mar_Fondo.mp4'),
          title:"_"+this.$i18n.t('services.interface'),
          title_noactive:this.$i18n.t('services.interface'),
          post:require('@/assets/img/UserInterface.jpg'),
          text:'services.textInterface'
        }
      ]

    }
  },
  mounted: function(){
    var div_services=document.getElementsByClassName('video-service-sm');
    var j=7;
    for (const div_sm of div_services) {
      div_sm.id="video_"+j;
      j++;
    }

  },
  methods:{

    setProject: function(clase){
      
      var clas;
      let imgs = document.querySelectorAll(".proyecto");
      this.show="none";
      this.animation="";
      this.animateDirection="";
      let row = document.querySelectorAll("#row-content");
      row.style="display:none";

      if(this.posicion>clase){
        
        this.animation="animate__animated";
        this.animateDirection= "animate__fadeInLeft";
      }
      if(this.posicion<clase){

        this.animation="animate__animated";
        this.animateDirection="animate__fadeInRight";
      }

      if(clase===0){
        clas="brand";
        this.posicion=1;
      }
      if(clase===1){
        clas="motion"
        this.posicion=2;
      }
      
      if(clase===3){
        clas="managment";
        this.posicion=4;
      }
      if(clase===4){
        clas="design-serv"
        this.posicion=5;
      }
      if(clase===6){
        clas="interface"
        this.posicion=6;
      }
      
      if(clase===2 || clase===5){
        this.posicion=0;
        for (const img of imgs) {
          img.style="display: block";
          row.style="display:block";
        }
      }
      else{
        for (const img of imgs) {
          img.style="display: none";
        }
        let img_brand= document.querySelectorAll("."+clas);

        if(img_brand.length===0){

          this.show="block";
          row.style="display:block";
        }
        for (const img of img_brand) {
          img.style="display:block";
          row.style="display:block";
        }
      
      }

      let linked="#nav"+this.posicion;
      location.href=linked;
      const links = document.querySelectorAll(".mynav a");
      const target = document.querySelector(".target");

      let element=document.querySelector("#nav"+this.posicion);

      for (let i = 0; i < links.length; i++) {
        if (links[i].classList.contains("active")) {
          links[i].classList.remove("active");
          links[i].classList.remove("active-col");
        }
        links[i].style.opacity = "1";
      }

      element.classList.add("active");
      element.classList.add("active-col");
      element.style.opacity = "1";

      const width = (element.getBoundingClientRect().width-58);
      const left = (element.getBoundingClientRect().left + window.pageXOffset+27);

      target.style.width = `${width}px`;
      target.style.left = `${left}px`;
      target.style.transition="all .4s ease-in-out";
      target.style.top=`${top}px`;

    },
    closeTarjet(id){
      console.log("se cierra el id: "+id);
      this.fadeRight="animate__fadeOutRight";
      this.slow=""

      let services=document.getElementsByClassName('a-service-sm');
      var div=document.querySelector("#id-div-svideo"+id)
      let i=0;

      div.classList.add('animate__animated', 'animate__fadeOutRight');

      for (const service of services) {
        service.innerHTML=this.slides[i].title_noactive;
        service.classList.remove('nohover');
        service.classList.remove('style-link');
        i++;
      }

      div.addEventListener('animationend', () => {
        if(this.fadeRight==="animate__fadeOutRight"){
          div.style.display="none";
        }
      });
    },
    setCurrentI: function(index,type){
      var services;
      var i=0;
      var div_video;
      var currentService;
      var src_cur;
      var post_cur;
      this.claseId=index;

      console.log("se abre el id: "+index);
      if(type===2){
        services=document.getElementsByClassName('a-service');

        for (const service of services) {
          service.innerHTML=this.slides[i].title_noactive;
          service.classList.remove('nohover');
          service.classList.remove('style-link');
          i++;
        }
//TAMBIEN HAY QUE CAMBIAR EL TITULO DEL VIDEO O EL TEXTO QUE TIENE ARRIBA
        currentService=document.getElementById('service'+index);
        // currentText=document.getElementById('video-text');
        div_video=document.getElementById("id-div-svideo");
        currentService.innerHTML = this.slides[index].title;
        // currentText.innerHTML = this.slides[index].text;
        this.titleSpan=this.slides[index].title;
        this.text_video=this.$i18n.t(this.slides[index].text);

        if(this.actived===index){
          this.actived=33;
          this.fadeRight="animate__fadeOutRight";

          for (const service of services) {
            service.innerHTML=this.slides[i].title_noactive;
            service.classList.remove('nohover');
            service.classList.remove('style-link');
            i++;
          }
        }
        else{
          this.fadeRight="animate__fadeInRight";
          this.actived=index;
          div_video.style="display: flex";
          currentService.classList.add('style-link');
          currentService.classList.add('nohover');
          post_cur=this.slides[index].post;
          this.$data.poster_url = post_cur;
          div_video.style="display: flex";
        }

      }  

      if(type===1){
        services=document.getElementsByClassName('a-service-sm');
        var divs=document.getElementsByClassName('div-svideo-sm');
        currentService=document.getElementById('service'+index);

        this.fadeRight="animate__fadeInRight";
        this.slow="animate__slow 0.5s"

        for (const div of divs) {
          div.style="display_none";
        }
        for (const service of services) {
          service.innerHTML=this.slides[i].title_noactive;
          service.classList.remove('nohover');
          service.classList.remove('style-link');
          i++;
        }
         console.log("esta activo este panel");
        div_video=document.getElementById("id-div-svideo"+index);
        this.text_video=this.$i18n.t(this.slides[index].text);
        src_cur=this.slides[index].src;
        this.$data.video_url = src_cur;

        post_cur=this.slides[index].post;
        this.$data.poster_url = post_cur;
        this.$data.text_video=this.$i18n.t(this.slides[index].text);

        this.$data.video_ref="video_"+index;

        console.log(this.$data.video_ref);
        currentService.classList.add('style-link');
        currentService.classList.add('nohover');
        currentService.innerHTML = this.slides[index].title;
        
        // vid=document.getElementById(this.$data.video_ref);
        // vid.load();
        // vid.play();
        div_video.style="display: flex";

      }

      const target = document.querySelector(".target");
      const active = document.querySelector(".mynav a.active");
      
      if (active) {
        const left = active.getBoundingClientRect().left + window.pageXOffset;
        const top = active.getBoundingClientRect().top + window.pageYOffset;
    
        target.style.left = `${left}px`;
        target.style.top = `${top}px`;
      }
    },
    setCurrent: function(index,type){
      
      var services;
      var i=0;
      var div_video;
      var currentService;
      var src_cur;
      var post_cur;
      var vid;

      if(type===2){
        services=document.getElementsByClassName('a-service');
        // var i=0;
        for (const service of services) {
          service.innerHTML=this.slides[i].title_noactive;
          service.classList.remove('nohover');
          service.classList.remove('style-link');
          i++;
        }
//TAMBIEN HAY QUE CAMBIAR EL TITULO DEL VIDEO O EL TEXTO QUE TIENE ARRIBA
        currentService=document.getElementById('service'+index);
        // currentText=document.getElementById('video-text');
        div_video=document.getElementById("id-div-svideo");
        currentService.innerHTML = this.slides[index].title;
        // currentText.innerHTML = this.slides[index].text;
        this.titleSpan=this.slides[index].title;
        this.text_video=this.$i18n.t(this.slides[index].text);
        console.log(this.slides[index].text);


        currentService.classList.add('style-link');
        currentService.classList.add('nohover');

        src_cur=this.slides[index].src;
        this.$data.video_url = src_cur;

        post_cur=this.slides[index].post;
        this.$data.poster_url = post_cur;
        vid = this.$refs.video_ser;
        vid.load();
        // vid.play();
        div_video.style="display: flex";

      }  

      if(type===1){
        services=document.getElementsByClassName('a-service-sm');
        var divs=document.getElementsByClassName('div-svideo-sm');
        for (const div of divs) {
          div.style="display_none";
        }
        for (const service of services) {
          service.innerHTML=this.slides[i].title_noactive;
          service.classList.remove('nohover');
          service.classList.remove('style-link');
          i++;
        }
        div_video=document.getElementById("id-div-svideo"+index);
        src_cur=this.slides[index].src;
        this.$data.video_url = src_cur;

        post_cur=this.slides[index].post;
        this.$data.poster_url = post_cur;

        console.log("este es el poster");
        console.log(this.$data.poster_url);
        this.$data.text_video=this.$i18n.t(this.slides[index].text);
        console.log(this.$data.text_video);

        this.$data.video_ref="video_"+index;

        console.log(this.$data.video_ref);
        
        vid=document.getElementById(this.$data.video_ref);
        vid.load();
        // vid.play();
        div_video.style="display: flex";

      }

      const target = document.querySelector(".target");
      const active = document.querySelector(".mynav a.active");
      
      if (active) {
        const left = active.getBoundingClientRect().left + window.pageXOffset+27;
        const top = active.getBoundingClientRect().top + window.pageYOffset;
    
        target.style.left = `${left}px`;
        target.style.top = `${top}px`;
      }
    },
    start_lg(){
      let scll = document.querySelector("body");
      this.minVideo="";
      this.enbebed="";
      this.videoService="video-service-lg";
      this.fullVideoLg="trailer-video";
      this.visibilityCloseLg = "flex";
      this.marg="margL"
      var span = this.$refs.span_title;
      // var vid = this.$refs.video_ser;
      this.animate="";
      this.fadeRight="";
      this.slow="";
      // vid.muted=false;
      // vid.play();
      span.style="display:block";
      scll.setAttribute("style", "overflow-y: hidden");
      
    },
    close_lg() {

      let scll = document.querySelector("body"); 
      // var vid = this.$refs.video_ser;
      this.minVideo="div-video-service";
      this.enbebed="embed-responsive";
      this.videoService="video-service";
      this.fullVideoLg="";
      this.visibilityCloseLg = "none";
      this.marg="marg"
      var span = this.$refs.span_title;
      this.animate="animate__animated";
      this.fadeRight="animate__fadeInRight";
      this.slow="animate__slow 0.5s";
      // vid.muted=true;
      span.style="display:none";
      scll.setAttribute("style", "overflow-y: visible");
    },
    start_lgV(){
      let scll = document.querySelector("body");
      this.minVideo="";
      this.enbebed="";
      this.videoService="video-service-lg";
      this.fullVideoLg="trailer-video";
      this.visibilityCloseLg = "flex";
      this.marg="margL"
      var span = this.$refs.span_title;
      // var vid = this.$refs.video_ser;
      this.animate="";
      this.fadeRight="";
      this.slow="";
      // vid.muted=false;
      // vid.play();
      span.style="display:block";
      scll.setAttribute("style", "overflow-y: hidden");
      
    },
    close_lgV() {

      let scll = document.querySelector("body"); 
      // var vid = this.$refs.video_ser;
      this.minVideo="div-video-service";
      this.enbebed="embed-responsive";
      this.videoService="video-service";
      this.fullVideoLg="";
      this.visibilityCloseLg = "none";
      this.marg="marg"
      var span = this.$refs.span_title;
      this.animate="animate__animated";
      this.fadeRight="animate__fadeInRight";
      this.slow="animate__slow 0.5s";
      // vid.muted=true;
      span.style="display:none";
      scll.setAttribute("style", "overflow-y: visible");
    }
  }
}
//HASTA AQUI FUNCIONABA 8:38 PM JULIO 8

</script>

<style>

.width-section{
  width: 100%;
}
.close-lg{
  position: absolute;
  right: 5%;
  top: 7%;
  cursor: pointer;
  z-index: 5;
  font-size: 50px;
  color: #FFFFFF;

}

.trailer-video{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background: #1D2B3C;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.trailer-back{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  background: transparent;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-resp{
  width: 100%;
  max-width: 1200px;
}

.marg{
  margin-top:18%;
  /* padding-top: 30px; */
}

.margL{
  margin-top:5%;
}

.ul-services{

    font-family: 'Gotham Book Regular';
    letter-spacing: 2.46px;
    font-size: 32px !important;
    line-height: 36px !important;
    text-align: left;
    margin-top: 12%;
    list-style: none;
    transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
    cursor: pointer;
}

.li-service a{
    color: #04182E !important;
    transform: all 500ms !important;
    position: relative !important;
    cursor: pointer;
}

.li-service a:not(.nohover):before{
    content: '';
    position: absolute !important;
    top: 30px !important;
    left: -20px !important;
    width: 0 !important;
    height: 2px !important;
    background:  #106180 !important;
    transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
}

.li-service a:not(.nohover):hover:before{
    width: 20px !important;
}
.li-service a:not(.nohover):hover{
    color: #106180 !important;
    margin-left: 20px !important;
    font-weight: bold;
} 
.a-service{ 
    color: #04182E !important;
    display: block !;
    text-decoration: none !important;
}

.a-service.style-link{
  color: #106180 !important;
  /* font-weight: bold !important; */
  font-family: 'Gotham Bold Regular';
}

.div-svideo{
  background: #106180;
  /* width: 100%; */
  width: 100%;
  height: 100%;
  margin-top: 3% !important;
  margin-right: 0;
  display:flex;
  justify-content: center;
  flex-flow: column wrap;
  display: none;
  margin-bottom: 10%;
  padding-bottom: 10%;

}
.div-video-service{
  width: 60% !important;
  height: 60% !important;
  margin-left: 20% !important;
  margin-bottom: 0;
  margin-right: 20%;
  margin-top: 0;
}
.title-video{
  width: 80% !important;
  height: 200px !important;
  margin-left: 10%;
}
.video-service{
  width: 100%;
  height: 100%;
}
.video-service-lg{
  width: 80%;
  /* height: 100%; */
}
.text-video-service{
  font-family: 'Gotham Book Regular';
  letter-spacing: 1.54px;
  font-size: 20px !important;
  line-height: 28px !important;
  text-align: justify;
  color: #ffffff;
  margin-top: 10%;
}

/* BUTTON-VIDEO-SERVICE */
.button-video-service:hover {
  background-position: 0 100%;
}

.button-video-service:hover .b-icon{
  color: #04182E !important;
}

.button-video-service{
  border: 1px solid #ffffff !important;
  position: absolute;
  cursor: pointer;
  bottom:36%;
  left:15%;
  padding: 8px 8px;
  text-align: center;
  
  background-size: 100% 200%;
  background-image: linear-gradient(to top, #ffffff 50%, transparent 50%);
  -webkit-transition: background-position 1s;
  -moz-transition: background-position 1s;
  transition: background-position 1s;
}

.button-video-service .b-icon{
  font-size: 30px !important;
  color: #ffffff;
}

/* button-proyect */
.btn_project:hover{
    background-position: -100% 0;
    color:#04182E !important;
}
.btn_project{
    font-family: "Gotham Book Regular" !important;
    letter-spacing: 0 !important;
    font-size: 20px !important;
    line-height: 21px !important;
    color: #ffffff !important;
    position: absolute;
    padding: 12px 20px;
    background: transparent;
    text-align: center;
    text-decoration: none;
    border: 1px solid #ffffff !important;
    border-radius: 0% !important;
    right: 10%;
    bottom: 13%;
    background-size: 200% 100%;
    background-image: linear-gradient(to right, transparent 50%, #fff 50%);
    -webkit-transition: background-position 1s;
    -moz-transition: background-position 1s;
    transition: background-position 1s;
}

.ul-services-sm{
  display: none;
}
.title-span{
  width: 600px;
  color:#fff;
  font-family: 'Gotham Book Regular';
  letter-spacing: 2.46px;
  font-size: 32px !important;
  line-height: 36px !important;
  position: absolute;
  left: 0rem ;
  bottom: 24rem ;
  text-align: left;
  -webkit-transform: rotate(-90deg); 
      -moz-transform: rotate(-90deg); 
      -ms-transform: rotate(-90deg); 
      -o-transform: rotate(-90deg); 
      transform: rotate(-90deg); 
      
      -webkit-transform-origin: 50% 50%; 
      -moz-transform-origin: 50% 50%; 
      -ms-transform-origin: 50% 50%; 
      -o-transform-origin: 50% 50%; 
      transform-origin: 50% 50%; 
      display: none;
}

@media screen and (max-width: 960px) and (min-width: 100px){
  .ul-services-sm{

      font-family: 'Gotham Book Regular';
      letter-spacing: 1.31px;
      font-size: 17px !important;
      line-height: 30px !important;
      text-align: left;
      margin-top: 10%;
      /* margin-left: 7%; */
      list-style: none;
      transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
      margin-left: -37px !important;
  }

  .cont-service-sm{
      /* margin-top: 6% !important; */
      margin-left: 6% !important;
  }


  .li-service-sm a{
      color: #04182E !important;
      transform: all 500ms !important;
      position: relative !important;
      margin-left: 20px;
  }

  .li-service-sm a:not(.nohover):before{
      content: '';
      position: absolute !important;
      top: 18px !important;
      left: -10px !important;
      width: 0 !important;
      height: 2px !important;
      background:  #106180 !important;
      transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
  }

  .li-service-sm a:not(.nohover):hover:before{
      width: 10px !important;
  }
  .li-service-sm a:not(.nohover):hover{
      color: #106180 !important;
      margin-left: 30px !important;
      font-weight: bold;
  } 
  .a-service-sm{ 
      color: #04182E !important;
      display: block !;
      text-decoration: none !important;
  }

  .a-service-sm.style-link{
    color: #106180 !important;
    font-family: 'Gotham Bold Regular';
  }


  /* .title-video{
    width: 80% !important;
    height: 50% !important;
    margin-left: 10%;
    margin-top: 10%;
  } */
  .div-svideo-sm{
    background: #106180;
    padding: 0;
    margin: -3px;
    width: 100vw;
    margin-bottom: 10%;
    /* height: 80vh; antesssss */
    /* height: 70vh; */
    display:flex;
    flex-flow: column wrap;
    display: none;
  }

  .div-video-service-sm{
    /* width: 70vw !important;
    height: 40vh !important; */
    width: 70% !important;
    /* margin-left: 15vw !important; */
    margin-left:15%;
    margin-right: 15%;
    margin-top:0;
    margin-bottom: 0;
  }
  .title-video-sm{
    /* width: 80vw !important;
    height: 30vh !important; */
    margin-left: 10%;
    margin-right: 10%;
  }
  .video-service-sm{
    width: 100%;
    height: 100%;
    /* margin-top: -30% !important; */
  }
  /* class para el tamaño del video cuando se reproduce desde play */
  .video-service-sml{
    width: 100%;
    height: 100%;
    /* margin-top: -30% !important; */
  }
  .text-video-service-sm{
    font-family: 'Gotham Book Regular';
    letter-spacing: 1.16px;
    font-size: 15px !important;
    line-height: 23px !important;
    text-align: justify;
    color: #ffffff;
    margin-top:10%;
  }
  /* .div-video-service-sm{
    width: 70% !important;
    height: 70% !important;
    margin-left: 15% !important;
  } */

  .ul-services{
    display: none;
  }

  .ul-services-sm{
    display: block;
  }


.button-video-service-sm:hover {
  background-position: 0 100%;
}

.button-video-service-sm:hover .b-icon{
  color: #04182E !important;
}

.button-video-service-sm{
  border: 1px solid #ffffff !important;
  position: relative;
  cursor: pointer;
  bottom: 8rem;
  left: 1rem;
  width: 40px !important;
  height: 40px !important;
  text-align: center;
  background-size: 100% 200%;
  background-image: linear-gradient(to top, #ffffff 50%, transparent 50%);
  -webkit-transition: background-position 1s;
  -moz-transition: background-position 1s;
  transition: background-position 1s;
}

.button-video-service-sm .b-icon{
  margin-top: 15%;
  font-size: 25px !important;
  color: #ffffff;
}

  .btn-project-sm{
    font-family: "Gotham Book Regular" !important;
    letter-spacing: 0 !important;
    font-size: 14px !important;
    line-height: 15px !important;
    color: #ffffff !important;
    position: relative;
    background: transparent;
    text-align: center;
    text-decoration: none;
    border: 1px solid #ffffff !important;
    border-radius: 0% !important;
    padding: 15px 25px;
    bottom: .7rem;
    left: 12rem;

    background-size: 200% 100%;
    background-image: linear-gradient(to right, transparent 50%, #fff 50%);
    -webkit-transition: background-position 1s;
    -moz-transition: background-position 1s;
    transition: background-position 1s;
  }
  .btn-project-sm:hover{
      background-position: -100% 0;
      color:#04182E !important;
  }

  .img-resp{
    width: 112%;
    margin-left: -6%;
  }

}

/* MEDIA PARA PANTALLA MEDIANA-GRANDE */
@media screen and (max-width: 1800px) and (min-width: 961px){

  .ul-services{

      font-family: 'Gotham Book Regular';
      letter-spacing: 2.30px;
      font-size: 25px !important;
      line-height: 30px !important;
      text-align: left;
      margin-top: 30%;
      list-style: none;
      transition: .25s .1s cubic-bezier(0, 1.07, 0, 1.02);
      margin-left: -30px !important;
  }

  .li-service a{
      color: #04182E !important;
      transform: all 500ms !important;
      position: relative !important;
  }

  .li-service a:not(.nohover):before{
      content: '';
      position: absolute !important;
      top: 20px !important;
      left: -15px !important;
      width: 0 !important;
      height: 2px !important;
      background:  #106180 !important;
      transition: all 300ms cubic-bezier(1, 0, 0, 1) !important;
  }
  .li-service a:not(.nohover):hover:before{
      width: 15px !important;
  }
  .li-service a:not(.nohover):hover{
      color: #106180 !important;
      margin-left: 15px !important;
      font-weight: bold;
  } 
  .a-service{ 
      color: #04182E !important;
      display: block !;
      text-decoration: none !important;
  }
  .div-svideo-sm{
    display: none;
  }
  .div-svideo{
    background: #106180;
    /* width: 90%; */
    width: 100%;
    height: 100%;
    margin-right: 0;
    margin-top: 5% !important;
    display:flex;
    justify-content: center;
    flex-flow: column wrap;
    margin-bottom: 10%;
    display: none;
  }

  .text-video-service{
    font-family: 'Gotham Book Regular';
    letter-spacing: 1.23px;
    font-size: 16px !important;
    line-height: 25px !important;
    text-align: justify;
    color: #ffffff;
    margin-top: 10%;
  }

  /* button-video-service */
/* ñññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññññ */
  .button-video-service{
    border: 1px solid #ffffff !important;
    position: absolute;
    cursor: pointer;
    padding: 6px 6px;
    text-align: center;

    left: 15.3%;
    bottom: 36%;
    /* bottom: 6rem;
    left: 7rem; */
    
    background-size: 100% 200%;
    background-image: linear-gradient(to top, #ffffff 50%, transparent 50%);
    -webkit-transition: background-position 1s;
    -moz-transition: background-position 1s;
    transition: background-position 1s;
  }

  .button-video-service .b-icon{
    font-size: 20px !important;
    color: #ffffff;
  }

  /* button project */

  .btn_project{
    font-family: "Gotham Book Regular" !important;
    letter-spacing: 0 !important;
    font-size: 15px !important;
    line-height: 16px !important;
    color: #ffffff !important;
    position: absolute;
    padding: 10px 15px !important;
    background: transparent;
    text-align: center;
    text-decoration: none;
    border: 1px solid #ffffff !important;
    border-radius: 0% !important;
    bottom: 15.4%;
    right: 10%;
    /* bottom: -33%;
    right: 39%; */
    

    background-size: 200% 100%;
    background-image: linear-gradient(to right, transparent 50%, #fff 50%);
    -webkit-transition: background-position 1s;
    -moz-transition: background-position 1s;
    transition: background-position 1s;
  }

  .title-span{
  width: 600px;
  color: white;
  font-family: 'Gotham Book Regular';
  letter-spacing: 1.54px;
  font-size: 20px !important;
  line-height: 28px !important;
  position: absolute;
  left: -8rem;
  bottom: 19rem;
  text-align: left;
  -webkit-transform: rotate(-90deg); 
      -moz-transform: rotate(-90deg); 
      -ms-transform: rotate(-90deg); 
      -o-transform: rotate(-90deg); 
      transform: rotate(-90deg); 
      
      -webkit-transform-origin: 50% 50%; 
      -moz-transform-origin: 50% 50%; 
      -ms-transform-origin: 50% 50%; 
      -o-transform-origin: 50% 50%; 
      transform-origin: 50% 50%; 
      display: none;
}

.img-resp{
  width: 100%;
  max-width: 900px;
}

.title-video{
  width: 80% !important;
  height: 200px !important;
  margin-left: 10%;
}


}

@media screen and (min-width: 1020px) and (max-width:1300px){
   .title-span{
  width: 600px;
  color: white;
  font-family: 'Gotham Book Regular';
  letter-spacing: 1.54px;
  font-size: 20px !important;
  line-height: 28px !important;
  position: absolute;
  left: -10rem;
  bottom: 22rem;
  text-align: left;
  -webkit-transform: rotate(-90deg); 
      -moz-transform: rotate(-90deg); 
      -ms-transform: rotate(-90deg); 
      -o-transform: rotate(-90deg); 
      transform: rotate(-90deg); 
      
      -webkit-transform-origin: 50% 50%; 
      -moz-transform-origin: 50% 50%; 
      -ms-transform-origin: 50% 50%; 
      -o-transform-origin: 50% 50%; 
      transform-origin: 50% 50%; 
      display: none;
}

}

</style>